import tw from "tailwind-styled-components";

export const Heading = tw.div`font-semibold text-base`;
